export default __webpack_public_path__ + "static/jumbotron-1-9a6b0465589d69317d325f205c2f79db.jpg";